import { render, staticRenderFns } from "./NewTransferAmountSelection.vue?vue&type=template&id=30b75dec&scoped=true&"
import script from "./NewTransferAmountSelection.vue?vue&type=script&lang=ts&"
export * from "./NewTransferAmountSelection.vue?vue&type=script&lang=ts&"
import style0 from "./NewTransferAmountSelection.vue?vue&type=style&index=0&id=30b75dec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b75dec",
  null
  
)

export default component.exports